var _rect, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAllergensLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      maxWidth: "100%",
      height: "auto"
    },
    width: 1023,
    height: 1023,
    viewBox: "0 0 1023 1023",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1023,
    height: 1023,
    fill: "#012590",
    x: 0,
    y: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#cbb26a"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(310,62) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(341,62) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(403,62) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(434,62) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(496,62) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(589,62) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(620,62) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(310,93) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(341,93) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(372,93) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(403,93) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(496,93) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(558,93) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(589,93) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(682,93) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(310,124) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(403,124) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(465,124) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(496,124) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(527,124) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(620,124) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(682,124) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(372,155) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(403,155) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(465,155) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(558,155) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(589,155) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(372,186) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(403,186) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(465,186) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(496,186) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(589,186) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(620,186) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(651,186) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(310,217) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(372,217) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(465,217) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(496,217) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(558,217) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(589,217) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(310,248) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(372,248) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(434,248) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(496,248) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(558,248) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(620,248) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(682,248) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(310,279) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(341,279) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(558,279) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(589,279) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(620,279) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(651,279) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(124,310) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(155,310) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(186,310) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(248,310) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(310,310) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(341,310) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(403,310) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(465,310) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(496,310) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(558,310) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(682,310) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(713,310) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(744,310) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(775,310) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(868,310) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(899,310) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(930,310) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(62,341) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(93,341) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(279,341) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(372,341) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(403,341) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(434,341) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(558,341) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(620,341) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(682,341) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(775,341) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(806,341) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(837,341) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(930,341) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(62,372) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(93,372) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(217,372) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(248,372) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(279,372) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(310,372) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(341,372) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(372,372) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(403,372) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(527,372) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(558,372) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(589,372) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(620,372) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(682,372) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(713,372) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(744,372) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(775,372) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(186,403) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(341,403) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(372,403) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(403,403) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(434,403) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(465,403) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(527,403) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(589,403) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(620,403) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(651,403) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(713,403) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(744,403) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(837,403) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(899,403) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(93,434) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(124,434) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(155,434) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(186,434) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(217,434) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(248,434) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(279,434) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(403,434) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(496,434) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(527,434) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(620,434) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(682,434) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(713,434) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(775,434) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(868,434) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(899,434) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(930,434) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(93,465) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(124,465) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(155,465) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(217,465) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(279,465) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(341,465) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(372,465) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(465,465) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(496,465) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(527,465) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(589,465) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(620,465) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(651,465) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(682,465) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(713,465) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(744,465) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(806,465) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(837,465) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(899,465) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(930,465) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(217,496) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(248,496) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(279,496) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(341,496) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(403,496) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(434,496) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(558,496) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(589,496) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(620,496) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(682,496) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(713,496) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(744,496) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(775,496) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(124,527) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(186,527) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(310,527) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(465,527) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(496,527) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(527,527) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(558,527) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(589,527) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(806,527) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(837,527) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(930,527) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(62,558) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(93,558) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(186,558) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(248,558) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(341,558) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(372,558) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(589,558) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(620,558) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(682,558) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(806,558) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(837,558) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(868,558) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(930,558) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(62,589) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(155,589) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(186,589) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(310,589) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(372,589) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(496,589) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(527,589) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(589,589) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(620,589) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(651,589) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(682,589) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(775,589) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(806,589) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(837,589) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(899,589) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(930,589) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(62,620) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(124,620) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(155,620) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(186,620) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(217,620) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(248,620) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(279,620) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(372,620) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(403,620) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(434,620) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(558,620) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(589,620) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(682,620) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(744,620) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(775,620) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(837,620) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(62,651) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(124,651) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(155,651) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(186,651) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(217,651) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(310,651) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(341,651) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(527,651) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(589,651) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(620,651) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(651,651) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(744,651) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(775,651) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(837,651) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(930,651) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(62,682) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(155,682) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(186,682) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(217,682) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(248,682) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(372,682) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(434,682) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(465,682) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(527,682) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(589,682) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(651,682) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(682,682) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(713,682) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(744,682) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(775,682) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(806,682) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(837,682) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(868,682) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(310,713) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(341,713) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(403,713) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(589,713) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(620,713) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(651,713) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(682,713) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(806,713) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(837,713) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(899,713) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(930,713) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(341,744) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(372,744) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(434,744) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(465,744) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(496,744) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(527,744) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(589,744) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(620,744) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(651,744) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(682,744) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(744,744) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(806,744) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(403,775) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(496,775) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(558,775) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(651,775) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(682,775) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(806,775) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(837,775) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(930,775) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(310,806) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(434,806) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(465,806) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(620,806) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(682,806) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(713,806) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(744,806) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(775,806) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(806,806) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(837,806) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(868,806) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(899,806) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(310,837) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(372,837) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(403,837) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(496,837) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(527,837) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(558,837) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(620,837) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(651,837) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(682,837) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(713,837) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(775,837) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(310,868) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(341,868) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(372,868) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(465,868) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(558,868) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(620,868) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(651,868) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(682,868) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(713,868) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(744,868) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(775,868) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(806,868) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(837,868) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(868,868) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(899,868) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(372,899) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(403,899) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(434,899) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(496,899) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(589,899) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(620,899) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(682,899) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(806,899) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(899,899) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(341,930) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(372,930) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(403,930) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(465,930) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(496,930) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(527,930) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(620,930) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(651,930) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(744,930) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(806,930) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(868,930) scale(5.3216666666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(62,62)",
    fill: "#cbb26a"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(15.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0v14h14V0H0z M12,12H2V2h10V12z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(744,62)",
    fill: "#cbb26a"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(15.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0v14h14V0H0z M12,12H2V2h10V12z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(62,744)",
    fill: "#cbb26a"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(15.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0v14h14V0H0z M12,12H2V2h10V12z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(124,124)",
    fill: "#cbb26a"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(15.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(806,124)",
    fill: "#cbb26a"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(15.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(124,806)",
    fill: "#cbb26a"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(15.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllergensLink);
export default __webpack_public_path__ + "static/media/AllergensLink.c69eec6de8437b05cefa25db29084e46.svg";
export { ForwardRef as ReactComponent };